export const lerp = (from, to, factor) => from + (to - from) * factor;
